<template>
    <pick-list :label="labelPosicao" v-model="posicao"
        :title="picklistPosicaoTitle"
        :columns="picklistPosicaoColumns"
        :search_OnClick="btnSearch_OnClick"
        :formatSelection="picklist_formatSelection"
        :hint="hintMessage"
        :readonly="readonly"
        :required="required"
        :rules="getRules"          
        itemKey="id">
    </pick-list>
</template>

<script>
import FormMixin from '@/mixin/form'
import PickList from '@/components/material/PickList'

import PosicaoApi from '@/api/workspace/success-factors/posicao'

export default {  
    mixins: [ FormMixin ],       
    components: {
        "pick-list": PickList
    },     
    props:{
        readonly:{
            required: false, 
            default: false,
            type: Boolean   
        },    
        required:{
            required: false, 
            default: false,
            type: Boolean   
        }, 
        rules:{
            required: false, 
            type: Array   
        },                
        empresa:{
            required: false,
            type: Object
        },        
        localidade:{
            required: false,
            type: Object
        },
        centroCusto:{
            required: false,
            type: Object
        },        
        title:{
            required: false, 
            type: String
        },
        label:{
            required: false, 
            type: String
        },
        value:{
            required: false,
            type: Object
        }
    },
    watch:{
        value(newValue, oldValue){
            if(newValue != oldValue){
                this.posicao = newValue;
            }
        }
    },    
    data () {
        return { 
            posicao: null,
            hintMessage: null
        }
    },     
    mounted(){
    },
    computed: {             
        labelPosicao () {
            if(this.label == null)
                return this.$t('Core.SuccessFactors.Posicao.PickList.posicao');
            else 
                return this.label;            
        },
        picklistPosicaoColumns(){
            return [
                { text: this.$t('Core.SuccessFactors.Posicao.PickList.nivel'), align: 'center', value: 'nivel' },
                { text: this.$t('Core.SuccessFactors.Posicao.PickList.codigo'), align: 'center', value: 'codigoSuccessFactors' },
                { text: this.$t('Core.SuccessFactors.Posicao.PickList.nome'), align: 'left', value: 'descricao' },
            ];            
        },
        picklistPosicaoTitle(){
            if(this.title == null)
                return this.$t('Core.SuccessFactors.Posicao.PickList.title');
            else 
                return this.title;
        },
        getRules(){
            if((this.rules || []).length > 0){
                return this.rules;
            }
            else{
                if(this.required == true){
                    return [
                        val => {
                            if((val || null) == null)
                                return this.$t("Core.SuccessFactors.Posicao.PickList.posicao-obrigatorio");

                            return true;
                        }
                    ];
                }
            }

            return [];
        }                                                             
    },   
    methods:{  
        async btnSearch_OnClick(){
            let posicao = await PosicaoApi.listar();
            let result = posicao.data;

            const self = this;
            if(self.empresa != undefined && self.empresa != null)
                result = result.filter(e => e.empresa.id == self.empresa.id );

            if(self.localidade != undefined && self.localidade != null)
                result = result.filter(l => l.localidade.id == self.localidade.id );                

            if(self.centroCusto != undefined && self.centroCusto != null)
                result = result.filter(l => l.centroCusto.id == self.centroCusto.id );                        
            
            return result;
        },    
        picklist_formatSelection(posicao){
            this.hintMessage = posicao.descricao;
            return `${posicao.descricao} (${posicao.codigoSuccessFactors})`;
        },               
    },
}
</script>

<style lang="scss" scoped>
@import "../../../styles/material-dashboard/variables";

</style>
